import { Component, computed, Signal, WritableSignal, signal } from '@angular/core';

import { ILevelGeneralData } from '../../models/level-general-data';
import { _FormModelService } from '../../services/model-services/_form-model.service';
import { _SectionBaseComponent } from './_section-base-component';
import { sectionLayout, TSectionLayout } from '../../models/section-layout';

@Component({
    selector: 'app-model-section',
    template: '',
    styles: []
})
export abstract class _SectionModelComponent<DataModel extends ILevelGeneralData>
    extends _SectionBaseComponent
{
    protected abstract readonly _formModelService: _FormModelService;

    abstract dataModel$$: Signal<DataModel> | WritableSignal<DataModel>;

    override readonly sectionLayout$$ = signal<TSectionLayout>(sectionLayout.form);

    protected _dataModel$$: Signal<DataModel> = computed(() => this._formModelService?.dataModel$$());
}
